module.exports = __webpack_public_path__ + "static/optimizationImg-2951bfd48a2e303fdcd5e53033efca34.svg";